import { vars } from "@imwebme/clay-token";
import { forwardRef } from "react";
import { match } from "ts-pattern";
import type { NumberBadgeProps } from "../../Badge";
import { NumberBadge } from "../../Badge";
import { Flex } from "../../utilities";
import type { LegacyTabProps } from "./TabList.types";

const iconPositionToFlexDirection = (position: LegacyTabProps<string>["iconPosition"]) => {
  switch (position) {
    case "left":
      return "row-reverse";

    case "bottom":
      return "column";

    case "top":
      return "column-reverse";

    default:
      return "row";
  }
};

/**
 * @deprecated 사용되지 않는 컴포넌트입니다. `Tabs` 컴포넌트를 사용하세요.
 */
export const LegacyTab = forwardRef(
  <T extends string>(
    {
      title,
      active,
      onClick,
      disabled,
      value,
      badge,
      icon,
      iconPosition,
      variant,
    }: LegacyTabProps<T>,
    ref: React.Ref<HTMLButtonElement>,
  ) => {
    const numberBadgeVariantMap = match(variant)
      .returnType<NumberBadgeProps["variant"]>()
      .with("squared", () => (active ? "primary-inverse" : "secondary"))
      .with("underline", () => (active ? "primary" : "secondary"))
      .otherwise(() => "primary");

    return (
      <Flex
        ref={ref}
        as="button"
        native={{
          role: "tab",
          id: `clay-tab-${value}`,
          "aria-selected": active,
          "aria-disabled": disabled,
          "aria-controls": `clay-tabpanel-${value}`,
          tabIndex: -1,
          onClick,
          disabled,
        }}
        alignItems="center"
        justifyContent="center"
        cursor="pointer"
        gap={vars.spacing[1]}
      >
        <Flex.Center
          position="relative"
          flexDirection={iconPositionToFlexDirection(iconPosition)}
          gap={vars.spacing[1]}
        >
          {title}

          {icon}
        </Flex.Center>

        {badge && variant && (
          <NumberBadge
            sx={{ position: "relative" }}
            variant={numberBadgeVariantMap}
            number={badge}
          />
        )}
      </Flex>
    );
  },
);
